import React from 'react';
import { ScanIcon, SearchIcon, ZapIcon, FileTextIcon, DatabaseIcon, LockIcon } from 'lucide-react';
export function Features() {
  return <section className="py-24 bg-white" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-gray-900 mb-6" data-id="element-35">
            Раскройте скрытую ценность ваших документов
          </h2>
          <p className="text-lg text-gray-500" data-id="element-36">
            ScanMind превращает ваши статичные PDF-архивы в динамичную базу
            знаний, обеспечивая новое поколение бизнес-аналитики.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-37">
          {/* Advanced OCR */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-38">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-39">
              <ScanIcon className="w-6 h-6 text-blue-900" data-id="element-40" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-41">
              Продвинутый OCR
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-42">
              Собственная легковесная технология OCR, которая точно обрабатывает
              сложные макеты, рукописный текст и сканы низкого качества.
            </p>
          </div>

          {/* Intelligent Search */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-43">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-44">
              <SearchIcon className="w-6 h-6 text-blue-900" data-id="element-45" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-46">
              Интеллектуальный поиск
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-47">
              Не просто храните файлы — понимайте их. Семантический поиск
              позволяет делать запросы к базе документов на естественном языке.
            </p>
          </div>

          {/* Real-time Processing */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-48">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-49">
              <ZapIcon className="w-6 h-6 text-blue-900" data-id="element-50" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-51">
              Обработка в реальном времени
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-52">
              Обрабатывайте тысячи страниц в минуту. Наш оптимизированный
              конвейер гарантирует, что данные будут готовы, когда они вам
              нужны.
            </p>
          </div>

          {/* Structure Extraction */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-53">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-54">
              <FileTextIcon className="w-6 h-6 text-blue-900" data-id="element-55" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-56">
              Извлечение структуры
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-57">
              Автоматическое определение и извлечение таблиц, пар
              «ключ-значение» и форм в структурированные данные JSON.
            </p>
          </div>

          {/* Seamless Integration */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-58">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-59">
              <DatabaseIcon className="w-6 h-6 text-blue-900" data-id="element-60" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-61">
              Бесшовная интеграция
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-62">
              Подключайтесь напрямую к вашим S3-хранилищам, Google Drive или
              корпоративным ERP-системам через наш надёжный API.
            </p>
          </div>

          {/* Enterprise Security */}
          <div className="p-8 rounded-xl bg-gray-50 border border-gray-200 hover:shadow-md transition-shadow duration-200" data-id="element-63">
            <div className="w-12 h-12 bg-blue-950/10 rounded-lg flex items-center justify-center mb-6" data-id="element-64">
              <LockIcon className="w-6 h-6 text-blue-900" data-id="element-65" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-66">
              Корпоративная безопасность
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-67">
              Соответствие SOC2 Type II. Ваши данные зашифрованы при хранении и
              передаче с гранулярным контролем доступа.
            </p>
          </div>
        </div>
      </div>
    </section>;
}